import React from 'react';
import { getLocalizedText } from '../lib/questionText';
import SentenceInput from './SentenceInput';
import {
  button,
  card,
  cardHeader,
  cardNumber,
  dangerButton,
  hint,
  input,
  label as labelStyle,
  warning,
} from '../../../shared/ui/formStyles';

const OPTION_LABELS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

// Задание с выбором варианта: правильные отмечаются галочками. Отметить можно
// несколько — тогда студент выбирает несколько вариантов, и ответ засчитается
// только при полном совпадении набора.
const ChoiceCard = ({ group, index, onChange, onCopy, onRemove }) => {
  const options = group.options || [];
  const text = getLocalizedText(group.label);
  const correctCount = options.filter((option) => option.isCorrect).length;
  const hasCorrect = correctCount > 0;
  const isMultipleChoice = correctCount > 1;

  const setText = (nextText) => {
    const ua = group.label?.ua;
    const en = group.label?.en;
    onChange({
      ...group,
      label: ua && ua !== en ? { ua, en: nextText } : { ua: nextText, en: nextText },
    });
  };

  const updateOption = (optionIndex, changes) =>
    onChange({
      ...group,
      options: options.map((option, i) => (i === optionIndex ? { ...option, ...changes } : option)),
    });

  const toggleCorrect = (optionIndex) =>
    onChange({
      ...group,
      options: options.map((option, i) =>
        i === optionIndex ? { ...option, isCorrect: !option.isCorrect } : option
      ),
    });

  return (
    <div style={card}>
      <div style={cardHeader}>
        <span style={cardNumber}>Питання {index + 1}</span>
        {!text.trim() && <span style={warning}>Немає тексту</span>}
        {!hasCorrect && <span style={warning}>Не позначено правильний</span>}
        {isMultipleChoice && (
          <span style={{ ...hint, margin: 0, color: '#2D9E6B', fontWeight: 600 }}>
            Кілька правильних: {correctCount}
          </span>
        )}

        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
          <button type="button" onClick={onCopy} style={button}>
            Копіювати
          </button>
          <button type="button" onClick={onRemove} style={dangerButton}>
            Видалити
          </button>
        </div>
      </div>

      <SentenceInput
        title="Текст питання"
        value={text}
        onChange={setText}
        placeholder="Наприклад: I ___ Anna ten years ago."
      />

      <div style={{ marginTop: '16px' }}>
        <span style={labelStyle}>Варіанти відповіді</span>
        <p style={{ ...hint, marginTop: 0, marginBottom: '10px' }}>
          Позначте галочкою кожен правильний варіант. Якщо правильних кілька, студент
          обиратиме їх усі, і відповідь зарахується лише за повного збігу.
        </p>

        {options.map((option, optionIndex) => (
          <div
            key={option.id || optionIndex}
            style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '8px' }}
          >
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                color: option.isCorrect ? '#2D9E6B' : '#94A3B8',
                fontWeight: 600,
                whiteSpace: 'nowrap',
              }}
            >
              <input
                type="checkbox"
                checked={Boolean(option.isCorrect)}
                onChange={() => toggleCorrect(optionIndex)}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              {option.isCorrect ? 'правильний' : 'зробити правильним'}
            </label>

            <input
              type="text"
              value={getLocalizedText(option.text)}
              placeholder={`Варіант ${option.label || OPTION_LABELS[optionIndex] || optionIndex + 1}`}
              onChange={(e) =>
                updateOption(optionIndex, { text: { ua: e.target.value, en: e.target.value } })
              }
              style={input}
            />

            {options.length > 2 && (
              <button
                type="button"
                onClick={() =>
                  onChange({ ...group, options: options.filter((_, i) => i !== optionIndex) })
                }
                style={dangerButton}
              >
                Прибрати
              </button>
            )}
          </div>
        ))}

        <button
          type="button"
          onClick={() =>
            onChange({
              ...group,
              options: [
                ...options,
                {
                  id: `${group.id}-o${options.length + 1}`,
                  label: OPTION_LABELS[options.length] || String(options.length + 1),
                  text: { ua: '', en: '' },
                  isCorrect: false,
                },
              ],
            })
          }
          style={button}
        >
          + Ще один варіант
        </button>
      </div>
    </div>
  );
};

export default ChoiceCard;
